import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { iif, of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  switchMap
} from 'rxjs/operators';
import { StateFacade as OverviewFacade } from '../../facades/state.facade';
import {
  FutureActivityDisabled,
  FutureActivityRequest
} from '../../models/api/future-activities.interfaces';
import { FutureActivityService } from '../../services/api/future-activities.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class FutureActivityEffects {
  loadActivityData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadFutureActivity),
      switchMap(() =>
        this.overview.futureActivityRequest$.pipe(
          distinctUntilChanged(
            (previous, current) =>
              JSON.stringify(previous) === JSON.stringify(current)
          ),
          filter((payload) => Object.keys(payload).length > 0),
          switchMap((payload) =>
            iif(
              () => 'disabled' in payload,
              of(
                OverviewActions.loadFutureActivitySuccess({
                  futureActivities: {
                    id: 'future-activity-content',
                    futureActivityContent: payload as FutureActivityDisabled
                  }
                })
              ),
              this.futureActivity
                .getFutureActivities(payload as FutureActivityRequest)
                .pipe(
                  filter((content) => !!content),
                  switchMap((content) => [
                    OverviewActions.loadFutureActivitySuccess({
                      futureActivities: {
                        id: 'future-activity-content',
                        futureActivityContent: content
                      }
                    })
                  ])
                )
            )
          )
        )
      ),
      catchError(() =>
        of(
          OverviewActions.loadFutureActivityFailure({
            error: {
              id: 'future-activity-content-error',
              futureActivityContentError: 'future-activity'
            }
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly futureActivity: FutureActivityService,
    private readonly overview: OverviewFacade
  ) {}
}
